{
    "CX_Record_Licences_None": "Geen",
    "CX_Record_Licences_CXRRecord": "CXR-registratie",
    "CX_Record_Licences_CXRUser": "CXR-gebruiker",
    "CX_Record_Licences_CXRManager": "CXR-manager",
    "CX_Record_Device_Or_Agent_Error": "Voor een {} abonnement is een agent of apparaat vereist.",
    "NAME": "CXRecordLanguage"
}